module.exports = __webpack_public_path__ + "img/ic-error-serial.svg";